export default __webpack_public_path__ + "static/media/Edit_Icon.e74ea36b.svg";